export default __webpack_public_path__ + "static/media/Microsoft_Teams_128x128.41d87906.webp";